import { RouteObject } from "react-router-dom"

import { DashboardStorefrontInsightsShow } from "~/src/components/DashboardStorefrontInsights/DashboardStorefrontInsightsShow"
import { ErrorPage } from "~/src/components/ErrorPage"
import { appClient } from "~/src/lib/appClients"

export const basename = "/dashboard/storefront_insights"

const createRoutes = (): RouteObject[] => [
  {
    path: basename,
    element: <DashboardStorefrontInsightsShow />,
    hydrateFallbackElement: <></>,
    errorElement: <ErrorPage />,
    async loader({ request }) {
      const url = new URL(request.url)

      const response = await appClient.get(`${basename}.json`, {
        headers: { Accept: "application/json" },
        params: url.searchParams,
      })

      return response.data
    },

    children: [
      /* TODO: Place child panel routes for their individual data fetchers here
      {
        path: "example",
        async loader({ request }): Promise<ExampleProps> {
          const url = new URL(request.url)

          const response = await appClient.get(`${url.pathname}.json`, {
            headers: { Accept: "application/json" },
          })

          return response.data
        },
      },
      */
    ],
  },
]

export default createRoutes
